import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CamelCasePipe } from './camel-case/camel-case.pipe';
import { CapitalizePipe } from './capitalize/capitalize.pipe';
import { FileNamePipe } from './file-name/file-name.pipe';
import { NumberToWordsPipe } from './number-to-words/number-to-words.pipe';

@NgModule({
  declarations: [NumberToWordsPipe, CamelCasePipe, CapitalizePipe, FileNamePipe],
  imports: [CommonModule],
  exports: [NumberToWordsPipe, CamelCasePipe, CapitalizePipe, FileNamePipe],
})
export class PipesModule {}
